import { SignUp } from '@clerk/clerk-react';

export function SignupPage() {
  return (
    <div className="signup-page">
      <SignUp />
    </div>
  );
}
